/* src/app/private/components/domain-authentication/add-auth-domain/add-auth-domain.component.scss */
label {
  font-weight: 600;
  margin-bottom: 10px;
}
.requiredValue::after {
  content: "*";
  color: red;
}
/*# sourceMappingURL=add-auth-domain.component.css.map */
